<template>
  <div class="flex flex-col items-start">
    <InputLabel v-if="props.label" :for="id" :optional="!props.required">
      {{ props.label }}
    </InputLabel>
    <div class="flex w-full">
      <div
        v-for="(option, index) in props.options"
        :key="index"
        class="relative mr-1.5 flex-1 select-none"
      >
        <BaseInput
          :id="`${id}_${index}`"
          v-model="value"
          class="peer"
          :checked="option.value === value"
          :value="option.value"
          hidden
          type="radio"
        />
        <label
          class="input flex cursor-pointer items-center justify-center text-black/50 peer-checked:border-black peer-checked:font-medium peer-checked:text-black"
          :for="`${id}_${index}`"
        >
          <span v-text="option.label" />
        </label>
      </div>
    </div>
    <InputError :error="errorMessage" />
  </div>
</template>

<script lang="ts" setup>
import type { InputProps } from './types'
import type { BaseInputProps } from '@/components/base/input/types'

interface InputRadioButtonsProps extends BaseInputProps, InputProps {
  options: {
    label: string
    value: number | string
  }[]
}

const props = withDefaults(defineProps<InputRadioButtonsProps>(), {
  disabled: false,
})

const { id, value, errorMessage } = useInput<number | string>(props.name)

onMounted(() => {
  if (!value.value) {
    value.value = props.options[0].value
  }
})
</script>
